import Typography from '@mui/material/Typography';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { ColumnHelper } from '@tanstack/react-table';

import MediaPlanCell from '../components/cells/MediaPlanCell';
import MediaPlanFilter from '../components/filters/MediaPlanFilter';
import { AlgorithmsStatus } from '../types';

/**
 * Builds the shared "Media Plan" display column used by every trafficking
 * table (Campaign, Ad Group, Advertiser). The route schema for each table
 * carries a `mediaPlan` search param, so we resolve it via a non-strict
 * `useSearch`.
 */
const createMediaPlanColumn = <
  TData extends { algorithms: AlgorithmsStatus[] },
>(
  columnHelper: ColumnHelper<TData>
) =>
  columnHelper.display({
    id: 'mediaPlan',
    enableSorting: false,
    header: () => (
      <Typography variant='body3' component='span'>
        Media Plan
      </Typography>
    ),
    cell: (props) => (
      <MediaPlanCell algorithmsStatus={props.row.original.algorithms} />
    ),
    size: 250,
    meta: {
      FilterComponentFn: (_column) => {
        const searchParams = useSearch({ strict: false });
        const navigate = useNavigate();

        return (
          <MediaPlanFilter
            filterId='mediaPlanFilter'
            buttonAriaLabel='media plan filter'
            searchParamMediaPlanId={searchParams.mediaPlan}
            handleNavigation={(mediaPlanId) => {
              void navigate({
                to: '.',
                search: {
                  ...searchParams,
                  mediaPlan: mediaPlanId,
                  page: 1,
                },
                resetScroll: false,
              });
            }}
          />
        );
      },
    },
  });

export default createMediaPlanColumn;
